/**
 * Created by Andrey Popov on 2/24/22.
 */

Telly.PRIZES.undersea3 = [
    [{
        units: [
            { currentType: "searesource", stage: 0 },
            { currentType: "seahero", stage: 0 },
            { code: "worker", stage: 0 }
        ]
    }],
    [{
        units: [
            { currentType: "searesource", stage: 1 },
            { currentType: "seahero", stage: 1 },
            { code: "worker", stage: 1 },
            { code: "seamagicplant", stage: 1 }
        ]
    }],
    [{
        units: [
            { currentType: "searesource", stage: 2 },
            { currentType: "seahero", stage: 2 },
            { code: "worker", stage: 2 },
            { code: "seamagicplant", stage: 1 },
            { code: "crystal", stage: 1 }
        ]
    }]
];

MissionTree.PRIZES.undersea3 = [{
    amount: 5,
    units: [
        { code: "seasnail", stage: 1 },
        { code: "seasnail", stage: 1 },
        { code: "seasnail", stage: 1 },
        { code: "seasnail", stage: 2 }
    ]
}];

Ruins.TIERS.undersea3 = {
    cheap: {
        soft: 59,
        rewards: [
            { code: "energy", stage: 0, amount: 1 },
            { code: "worker", stage: 0, amount: 1 },
            { code: "seastrawberry", stage: 0, amount: 2 }
        ]
    },
    costly: {
        hard: 249,
        rewards: [
            { code: "energy", stage: 2, amount: 2 },
            { code: "crystal", stage: 2, amount: 3 },
            { code: "seasack", stage: 2, amount: 1 },
            { code: "worker", stage: 4, amount: 1 }
        ]
    }
};

AchievementsConfig.registerExpedition("undersea3", {
    force: Forces.LANDMARK_DONOR_SLOT2,
    target: { code: "rpcustomermain0a", stage: 0 },
    donors: ["rpcustomermain0a", "rpcustomermain1a", "rpcustomermain2a", "rpcustomermain3a"]
});

const Undersea3SourceMine = {
    prize: function (level, unit) {
        const sourceAmounts = [2, [2, 3], [3, 4], [4, 5], [5, 6]];
        const chestStages = [0, 0, 0];

        if (level === unit.getData().mineable.tasks.length - 1) {
            return [{
                units: [{ code: `${unit.getResource()}chest`, stage: chestStages[unit.stage] }]
            }];
        }

        return [{
            amount: sourceAmounts[level],
            units: [{ code: unit.getResource(), stage: 0 }]
        }, {
            amount: [1, 3],
            units: [{ code: "seasnail", stage: 0 }]
        }];
    }
};

const Undersea3FruitMine = {
    prize: function (level, unit) {
        return [{
            amount: 5,
            probabilities: [0.166, 0.166, 1],
            units: [
                { code: unit.code, stage: 1 },
                { code: "coins", stage: 0 },
                { code: unit.code, stage: 0 }
            ]
        }];
    }
};

const Undersea3GeneratorMine = {
    prize: function (level, unit) {
        return [{
            amount: 3,
            probabilities: [0.75, 0.25],
            units: [
                { code: `${unit.getResource()}source`, stage: 0 },
                { code: unit.getResource(), stage: 0 }
            ]
        }, {
            amount: [2, 5],
            units: [
                { code: "seasnail", stage: 0 },
                { code: "seasnail", stage: 1 }
            ]
        }];
    }
};

Mines.seafruit = Undersea3FruitMine.prize;
Mines.seasource = Undersea3SourceMine.prize;
Mines.seagrowing = WandsGrowing.prize;
Mines.seagenerator = Undersea3GeneratorMine.prize;

CustomerRecipes.undersea3 = cleverapps.clone(CustomerRecipes.universal, true);
CustomerRecipes.undersea3.rpproducer0_0[0].cookingDuration = "10 minutes";
CustomerRecipes.undersea3.rpproducer0_0[0].ingredients[0] = {
    code: "seastrawberry",
    stage: 4,
    amount: 1
};
CustomerRecipes.undersea3.rpcustomerbridge1_0[0].requiredUnits[0].code = "rpcustomermain0a";
CustomerRecipes.undersea3.rpcustomerbridge1_0[0].requiredUnits[0].stage = 2;
CustomerRecipes.undersea3.rpcustomerbridge2_0[0].requiredUnits[0].code = "rpcustomermain1a";
CustomerRecipes.undersea3.rpcustomerbridge3_0[0].requiredUnits[0].code = "rpcustomermain2a";

CustomerRecipes.undersea3.rpproducer1_0[0].requiredUnits[0].code = "rpcustomermain0a";
CustomerRecipes.undersea3.rpproducer2_0[0].requiredUnits[0].code = "rpcustomermain1a";
CustomerRecipes.undersea3.rpproducer3_0[0].requiredUnits[0].code = "rpcustomermain2a";

CustomerRecipes.undersea3.rpcustomerbridge0_0[0].ingredients[0].type = "searesource";
CustomerRecipes.undersea3.rpcustomerbridge0_0[0].ingredients[0].code = undefined;
CustomerRecipes.undersea3.rpcustomerbridge0_0[0].ingredients[0].amount = 1;

CustomerRecipes.undersea3.rpcustomermain0a_1 = [
    {
        ingredients: [{
            code: "rpproduct0",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.undersea3.rpcustomermain1a_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain0a", stage: 1 }],
        ingredients: [{
            code: "rpproduct1",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.undersea3.rpcustomermain2a_0 = [
    {
        ingredients: [{
            code: "rpproduct2",
            stage: 0,
            amount: 1
        }]
    }
];
CustomerRecipes.undersea3.rpcustomermain3a_0 = [
    {
        ingredients: [{
            code: "rpproduct3",
            stage: 0,
            amount: 1
        }]
    }
];

delete CustomerRecipes.undersea3.rpcustomermain0_0;
delete CustomerRecipes.undersea3.rpcustomermain1_0;
delete CustomerRecipes.undersea3.rpcustomermain2_0;
delete CustomerRecipes.undersea3.rpcustomermain3_0;

cleverapps.styles.undersea3 = {
    fogBlockWand: {
        x: { align: "left", dx: -7 },
        y: { align: "center", dy: 15 }
    }
};

cleverapps.styles.undersea3[PixelsSwarm.ADS] = {
    distanceDisappear: 1000,
    speed: { x: 35, y: -18 },
    collect: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        delay: 150
    }
};

Climbable.TRIGGERS.undersea3 = {
    rpcustomermain0a_0: { code: "rpcustomerbridge0", stage: 1 }
};
UnitsLibrary.CODES_BY_TAB.undersea3 = [
    ["seahero", "searubyhero"],
    ["searesource"],
    ["seafruit"],
    ["seagrowing", "seasource"],
    ["seachest"],
    ["seamagicplant", "snailfeast", "snailhouse"]
];
UnitsLibrary.EXPEDITION_PREFIXES.undersea3 = "sea";

ShopWindow.TABS.UNITS_EXPEDITION_UNDERSEA3 = 29;

UnitsShop.SHOPS.undersea3 = [{
    tab: ShopWindow.TABS.UNITS_EXPEDITION_UNDERSEA3,
    unit: { code: "seashop", stage: 0 }
}];

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_EXPEDITION_UNDERSEA3] = {
    refreshTimeout: "6 hours",
    refreshPrice: 199,

    default: [{
        unit: {
            code: "sea2walrusruby",
            stage: 0,
            amount: 1,
            onlyIfNotDone: true
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "walrusruby",
            stage: 0,
            amount: 1,
            onlyIfNotDone: true
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "searudolf",
            stage: 0,
            amount: 1
        },
        price: 1500,
        type: Product.TYPE_HARD,
        left: 1
    }, {
        unit: {
            code: "seafreechest",
            stage: 0,
            amount: 1
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "seasack",
            stage: 0,
            amount: 2
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "seasack",
            stage: 2,
            amount: 1
        },
        price: 149,
        type: Product.TYPE_HARD,
        left: 3
    }, {
        unit: {
            code: "seashopchest",
            stage: 0,
            amount: 1
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 10
    }, {
        unit: {
            code: "seashopchest",
            stage: 1,
            amount: 1
        },
        price: 129,
        type: Product.TYPE_HARD,
        left: 15
    }, {
        unit: {
            code: "seashopchest",
            stage: 2,
            amount: 1
        },
        price: 319,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 1
        },
        price: 119,
        type: Product.TYPE_HARD,
        left: 5
    }, {
        unit: {
            code: "worker",
            stage: 4,
            amount: 1
        },
        price: 79,
        type: Product.TYPE_HARD,
        left: 5
    }]
};

PixelsPlanner.AVAILABLE.undersea3 = {
    fog: "fog3"
};

PixelsSwarm.UNDERSEA3 = "undersea3";

PixelsSwarmConfig[PixelsSwarm.UNDERSEA3] = {
    pages: ["undersea3"],
    reward: [{
        units: [
            { currentType: "searesource", stage: 0 },
            { currentType: "seahero", stage: 0 },
            { code: "seamagicplant", stage: 0 },
            { code: "seastrawberry", stage: 0 }
        ]
    }]
};

PixelsSwarmConfig[PixelsSwarm.ADS].pages.push("undersea3");

cleverapps.styles.PixelView[PixelsSwarm.UNDERSEA3] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {}, true);